import { LOCATION_GONE_MESSAGE } from "../_helpers/editLocation";

// What the last Edit Location save did, on the client detail page: saved (by
// the edited location's row), or the location gone (above the list, since the
// re-read takes its row away).
export type LocationEditOutcome =
    | { kind: "saved"; locationId: string; sentBackToReview: boolean }
    | { kind: "gone"; locationId: string };

interface EditLocationOutcomeProps {
    outcome: LocationEditOutcome;
}

export const EditLocationOutcome = ({ outcome }: EditLocationOutcomeProps) => {
    if (outcome.kind === "gone") {
        return (
            <p role="alert" className="text-error">
                {LOCATION_GONE_MESSAGE}
            </p>
        );
    }

    return (
        <p role="status" className="font-medium">
            {outcome.sentBackToReview
                ? "Changes saved. The location is back in review."
                : "Changes saved."}
        </p>
    );
};
